// Session-scoped geocoding cache to avoid redundant Google Geocoding API calls.
// Keyed by normalized address string. No TTL — addresses don't move within a session.

const cache = new Map();

export async function geocodeWithCache(address) {
  const key = address.trim().toLowerCase();

  if (cache.has(key)) {
    return cache.get(key);
  }

  const geocoder = new window.google.maps.Geocoder();
  const result = await new Promise((resolve, reject) => {
    geocoder.geocode({ address }, (results, status) => {
      if (status === 'OK' && results[0]) {
        const loc = results[0].geometry.location;
        resolve({ lat: loc.lat(), lng: loc.lng() });
      } else {
        reject(new Error(`Geocoding failed for "${address}": ${status}`));
      }
    });
  });

  cache.set(key, result);
  return result;
}

export function clearGeocodeCache() {
  cache.clear();
}
